enum BackgroundStyle {
  Unknown = 'unknown',
  Opaque = 'opaque',
  Transparent = 'transparent',
  TransparentLight = 'transparent-light',
  TransparentDark = 'transparent-dark'
}

export default BackgroundStyle;



// WEBPACK FOOTER //
// ./src/data/BackgroundStyle.ts